module.exports = __webpack_public_path__ + "img/SchlafDerGerechten.2e1a8669.jpg";